import { useState } from "react";
import { useSelector } from "react-redux";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import trashIcon from "../../../../images/icons/delete.svg";
import DeleteModal from "../../../common/DeleteModal";
import UsersService from "../../../../services/UsersService";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);

	return (
		<tr key={index} className="text-center">
			<td>{item?.fullname || "-"}</td>
			<td>{item?.phone || "-"}</td>
			<td>{item?.email || "-"}</td>
			<td>{item?.age || "-"}</td>
			<td>
				<Badge variant={!item?.isDeleted ? "primary light" : "danger light"}>
					{Translate[lang][!item?.isDeleted ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				{!item?.isDeleted && isExist("delete_users") && (
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				)}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.fullname}
					deletedItem={item}
					modelService={new UsersService()}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
